import { AIHistoryRecord } from '../type';

export const timestampHeader = (headerAbbr?: string | null): string =>
  headerAbbr ? `Timestamp (${headerAbbr})` : 'Timestamp';

// A row across a DST switch (e.g. CST under a CDT header) keeps its own zone.
export const rowTimestamp = (
  record: Pick<AIHistoryRecord, 'timestamp' | 'timezone_abbr'>,
  headerAbbr?: string | null
): string => {
  const value = record.timestamp || '';
  const abbr = record.timezone_abbr;
  return value && abbr && abbr !== headerAbbr ? `${value} ${abbr}` : value;
};
